import GrantingMonitorScreen from './GrantingMonitorScreen';

export default GrantingMonitorScreen;
